export const retryOperation = async (
  operation,
  maxTries = 3,
  waitTime = 1000
) => {
  let attempt = 0;
  while (attempt < maxTries) {
    try {
      await operation();
      return; // Exit if operation is successful
    } catch (error) {
      attempt++;
      if (attempt >= maxTries) {
        throw error; // Rethrow the error if max tries are exceeded
      }
      await new Promise((resolve) => setTimeout(resolve, waitTime)); // Wait before retrying
    }
  }
};
